import { render, staticRenderFns } from "./start-modal.component.vue?vue&type=template&id=48117444"
import script from "./start-modal.component.vue?vue&type=script&lang=js"
export * from "./start-modal.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports